import { render, staticRenderFns } from "./dialog_t2.vue?vue&type=template&id=1b3f96e2&scoped=true&"
import script from "./dialog_t2.vue?vue&type=script&lang=js&"
export * from "./dialog_t2.vue?vue&type=script&lang=js&"
import style0 from "./dialog_t2.vue?vue&type=style&index=0&id=1b3f96e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f96e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
